import grammarly_logo from "../../assets/img/Cases/grammarly_logo.svg";
import cartinuity_logo from "../../assets/img/Cases/cartinuity_logo.svg";
import a2b_logo from "../../assets/img/Cases/a2b_logo.svg";
import pango_logo from "../../assets/img/Cases/pango.svg";
import emerge_logo from "../../assets/img/Cases/emerge.svg";
import invet_logo from "../../assets/img/Cases/invet.svg";
import nextres from "../../assets/img/Cases/nextres.svg";
import weedar from "../../assets/img/Cases/weedar.svg";
import shapely from "../../assets/img/Cases/shapely.svg";
import pizza from "../../assets/img/Cases/pizza_puzzle.svg";

export const data = [
  {
    link: "pdf",
    pfdUrl: "/pdf/PuzzleCase.pdf",
    logo: pizza,
    description:
      "PuzzlePizza offers a customizable pizza experience that allows customers to make their own pizzas by selecting the types of pizza they want on top of their crusts. This allows customers to experience the flavors in one pizza.",
  },
  {
    link: "shapely",
    logo: shapely,
    description:
      "Shapely is a daily workout app with routines for all your main muscle groups. In just a few minutes a day, you can build muscles and stay fit without having to join a gym.",
  },
  {
    link: "weedar",
    logo: weedar,
    description:
      "WeedAr is a fully-integrated ecosystem that connects cannabis brands to a revolutionary loyalty and distribution platform, powered by unique cutting edge technology.",
  },
  {
    link: "nextres",
    logo: nextres,
    description:
      "Nextres is a package of products that supports brokers and borrowers in getting mortgage loans.",
  },
  {
    link: "grammarly",
    logo: grammarly_logo,
    description: "Read how we helped people become more literate online.",
  },
  {
    link: "cartinuity",
    logo: cartinuity_logo,
    description:
      "Cartinuity solves fundamental dilemmas of consumer shopping needs - customize the shopping experience for customers based on their immediate demand.",
  },
  {
    link: "a2b",
    logo: a2b_logo,
    description:
      "Read how we helped fill all the trucks by combining orders from different forwarders.",
  },
  {
    link: "pango",
    logo: pango_logo,
    description:
      "Pango Inc. provides businesses and consumers with advanced technologies to enable secure and private web browsing.",
  },
  {
    link: "emerge",
    logo: emerge_logo,
    description:
      "Emerge was born out of a desire to leverage frontier technologies to enable meaningful shared experiences.",
  },
  {
    link: "invet",
    logo: invet_logo,
    description:
      "Invet.ua is a Ukrainian vet drugs distribution company operating for more than 10 years on the market.",
  },
];
